import axios from 'axios';
import { BaseUrl } from '../../server';

export const getAllVideoCategorys = (page,limit ) => async (dispatch) => {
    try {
        // إرسال طلب بدء جلب البيانات
        dispatch({ type: 'get_all_videoCategorys_request' });

        // إضافة Pagination إلى query parameters
        const { data } = await axios.get(`${BaseUrl}/videoCategory`, {
            params: {
                page,
                limit
            },
        });

        // إرسال البيانات بنجاح مع معلومات Pagination
        dispatch({
            type: 'get_all_videoCategorys_success',
            payload: {
                videoCategorys: data.videoCategorys,
                pagination: data.pagination,
            },
        });

    } catch (error) {
        // إرسال خطأ في حالة فشل الطلب
        dispatch({
            type: "get_all_videoCategorys_error",
            payload: error.response?.data?.message || "حدث خطأ ما",
        });
    }
};

export const getFillterVideoCategorys = (page , limit ,titleAr,titleEn) => async (dispatch) => {
    try {
        // إرسال طلب بدء جلب البيانات
        dispatch({ type: 'get_Fillter_videoCategorys_request' });

        // إضافة Pagination إلى query parameters
        const { data } = await axios.get(`${BaseUrl}/videoCategory/filter`, {
            params: {
                page,
                limit,
                titleAr,
                titleEn,
                
            },   withCredentials: true,
        });

        // إرسال البيانات بنجاح مع معلومات Pagination
        dispatch({
            type: 'get_Fillter_videoCategorys_success',
            payload: {
                videoCategorys: data.videoCategorys,
                pagination: data.pagination, // معلومات Pagination من الخادم
            },
        });

    } catch (error) {
        // إرسال خطأ في حالة فشل الطلب
        dispatch({
            type: "get_Fillter_videoCategorys_error",
            payload: error.response?.data?.message || "حدث خطأ ما",
        });
    }
};
export const getVideoCategory= (id) => async (dispatch) => {
    try {
       
        dispatch({ type: 'get_videoCategory_request' });

        const { data } = await axios.get(`${BaseUrl}/videoCategory/${id}`);
        console.log("data",data);
        dispatch({ type: 'get_videoCategory_success' ,payload:data.videoCategory});

    } catch (error) {
        dispatch({
            type: "get_videoCategory_error",
            payload: error.response.data.message,
          });
    }
}